import { useCallback } from "react";

const useformatted = () => {
  const formattedSlug = useCallback((data: string) => {
    return data
      .normalize("NFD")
      .toLowerCase()
      .trim()
      .replace(/[\s]+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/--+/g, "-");
  }, []);

  const formattedDate = useCallback((date: string) => {
    const dateObj = new Date(date);
    const day = dateObj.getUTCDate();
    const monthNew = dateObj
      .toLocaleDateString("es-ES", { month: "short", timeZone: "UTC" })
      .toUpperCase();
    const year = dateObj.getUTCFullYear();
    return `${day} ${monthNew}, ${year}`;
  }, []);

  return { formattedSlug, formattedDate };
};

export default useformatted;
